import React from 'react';
import { getAuthCookie } from '../utils/cookies';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import ClockoutController from '../core/clockout.controller';

import Login from '../components/login/login';
import Signup from '../components/signup/signup';
import ResetPassword from '../components/reset-password/reset-password';
import Dashboard from '../components/dashboard/dashboard';
import Ledger from '../components/ledger/ledger';
import Reconciliation from '../components/reconciliation/reconciliation';
import User from '../components/users/user/user';
import Treasury from '../components/treasury/treasury';
import Team from '../components/team/team';
import Billing from '../components/billing/billing';
import Account from '../components/account/account';
import Reports from '../components/reports/reports';
import Configuration from '../components/configurations/configuration';

// Create a wrapper component that handles authentication
const ProtectedRoute = ({ children }) => {
    const isAuthenticated = getAuthCookie() !== 'expired';
    console.log('isAuthenticated', isAuthenticated);
    return isAuthenticated ? children : <Navigate to="/" />;
};

const PublicRoute = ({ children }) => {
    const isAuthenticated = getAuthCookie() !== 'expired';
    return isAuthenticated ? <Navigate to="/dashboard" /> : children;
};

export default class ClockoutRouter extends React.Component {
    state = { authVersion: 0 }; // Dummy state to force re-renders

    componentDidMount() {
        // Subscribe to auth changes
        ClockoutController._notifyAuthChange = () => {
            this.setState((prev) => ({ authVersion: prev.authVersion + 1 }));
        };
    }

    render() {
        const router = createBrowserRouter([
            {
                path: '/',
                element: (
                    <PublicRoute>
                        <Login />
                    </PublicRoute>
                )
            },
            {
                path: '/signup',
                element: (
                    <PublicRoute>
                        <Signup />
                    </PublicRoute>
                )
            },
            {
                path: '/reset-password',
                element: (
                    <PublicRoute>
                        <ResetPassword />
                    </PublicRoute>
                )
            },
            {
                path: '/dashboard',
                element: (
                    <ProtectedRoute>
                        <Dashboard />
                    </ProtectedRoute>
                )
            },
            {
                path: '/users',
                element: (
                    <ProtectedRoute>
                        <Team />
                    </ProtectedRoute>
                )
            },
            {
                path: '/ledger',
                element: (
                    <ProtectedRoute>
                        <Ledger />
                    </ProtectedRoute>
                )
            },
            {
                path: '/team',
                element: (
                    <ProtectedRoute>
                        <Team />
                    </ProtectedRoute>
                )
            },
            {
                path: '/reconciliation',
                element: (
                    <ProtectedRoute>
                        <Reconciliation />
                    </ProtectedRoute>
                )
            },
            {
                path: '/configurations',
                element: (
                    <ProtectedRoute>
                        <Configuration />
                    </ProtectedRoute>
                )
            },

            {
                path: '/users/user',
                element: (
                    <ProtectedRoute>
                        <User />
                    </ProtectedRoute>
                )
            },
            {
                path: '/treasury',
                element: (
                    <ProtectedRoute>
                        <Treasury />
                    </ProtectedRoute>
                )
            },
            {
                path: '/billing',
                element: (
                    <ProtectedRoute>
                        <Billing />
                    </ProtectedRoute>
                )
            },
            {
                path: '/account',
                element: (
                    <ProtectedRoute>
                        <Account />
                    </ProtectedRoute>
                )
            },
            {
                path: '/reports',
                element: (
                    <ProtectedRoute>
                        <Reports />
                    </ProtectedRoute>
                )
            }
        ]);
        return <RouterProvider router={router} />;
    }
}
